import script from "./SelfAssessment.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfAssessment.vue?vue&type=script&setup=true&lang=js"

import "./SelfAssessment.vue?vue&type=style&index=0&id=4b77f4db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b77f4db"]])

export default __exports__